import { render, staticRenderFns } from "./OrderAdmittanceButtons.vue?vue&type=template&id=592537c3&"
import script from "./OrderAdmittanceButtons.vue?vue&type=script&lang=js&"
export * from "./OrderAdmittanceButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtn,QTooltip,QBadge} from 'quasar'
component.options.components = Object.assign({QBtn,QTooltip,QBadge}, component.options.components || {})
